module.exports = __webpack_public_path__ + "img/airtm-verification.491c5df9.png";